import helpers from './helpers';

function buildIframe(youtubeId) {
  const iframe = document.createElement('iframe');
  const params = 'autoplay=1&rel=0&modestbranding=1&playsinline=1';

  iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?${params}`;
  iframe.title = 'YouTube video player';
  iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('frameborder', '0');

  return iframe;
}

function loadVideo(video) {
  if (video.classList.contains('is-loaded')) return;

  const youtubeId = video.getAttribute('data-yt-id');
  const iframeWrapper = video.querySelector('.inline-video__iframe');

  if (!youtubeId || !iframeWrapper) return;

  const iframe = buildIframe(youtubeId);
  iframeWrapper.appendChild(iframe);
  video.classList.add('is-loaded');
  iframe.focus();
}

export default (function () {
  return {
    init() {
      const triggers = document.querySelectorAll('.js-inline-video[data-yt-id] .inline-video__poster');
      if (!triggers.length) return;

      helpers.forEach(triggers, (trigger) => {
        trigger.addEventListener('click', () => {
          loadVideo(trigger.closest('.js-inline-video'));
        });
      });
    },
  };
})();
